export default "__VITE_ASSET__KWfJigg___"